import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Observable, Subject } from 'rxjs';
import {
  BaseAuthenticatedService,
  httpQueryParams,
  PaginatedResponse,
  RecursiveInterface,
} from './base-authenticated.service';
import { ActivatedRoute } from '@angular/router';
import { Organizations } from '@app/interface/organizations';

@Injectable({
  providedIn: 'root',
})
export class OrganizationApi extends BaseAuthenticatedService {
  constructor(
    public override auth: AngularFireAuth,
    public override httpClient: HttpClient, // private cookieService: CookieService
    private route: ActivatedRoute, // Inject ActivatedRoute
  ) {
    super(auth, httpClient);
  }

  public getOrganization<T = Organizations>(
    organization_id: number,
    params: httpQueryParams = {},
  ): Observable<T> {
    const path = `api/organizations/${organization_id}/`;
    // Use simple get for single resource, not recursive
    return this.get<T>(path, params);
  }

  public updateOrganizationDetails(
    organization_id: number | null,
    id: number,
    data: Partial<Organizations>,
  ): Observable<Organizations> {
    // console.log(data);
    return this.partialUpdate<Organizations>(
      `api/organizations/${organization_id}/`,
      {}, //{ withCredentials: true },
      data,
    );
  }

  public updateOrganizationWithFile(
    organization_id: number,
    data: FormData,
  ): Observable<Organizations> {
    return this.partialUpdate<Organizations>(
      `api/organizations/${organization_id}/`,
      {},
      data,
    );
  }

  public getOrganizationTotalInvoiceAmount(
    organization_id: number,
    year: number,
  ): Observable<number> {
    // Add trailing slash
    const path = `api/organizations/${organization_id}/get_annual_total_invoice_amount/`;
    const params = { year: year.toString() };

    return this.get<number>(path, params);
  }
}
